import { SEARCH_RESULT_CATEGORY_ID } from '../../../model/constants';
import { LogicContext } from '../types';
import { groupItemsByTypes } from '../utils';
import config from '../../../config';

export const fetchSearchResultsContent = async (context: LogicContext) => {
  const {
    search: { searchItems, currentType },
    controllersData,
  } = context;
  const locale = config.locale;
  const currency = context.user?.currency || config.default_currency;

  const grouppedItems = groupItemsByTypes(searchItems);

  const [, searchHeader] =
    controllersData.search?.components.find(
      ([, comp]) => comp.type === 'SearchHeader'
    ) || [];

  const searchCategory = {
    component_type: 'game_grid',
    id: SEARCH_RESULT_CATEGORY_ID,
    title: `Search Results`,
    type: 'Game List',
    staticTexts: searchHeader?.properties.staticTexts,
    slides: [
      {
        type: 'Game List',
        gameList: grouppedItems[currentType],
        gamesLimit: undefined,
      },
    ],
  };

  return {
    updates: [
      {
        type: 'hideLayoutComponent',
        data: `SearchNoResults`,
      },
      {
        type: 'hideLayoutComponent',
        data: `SearchHeader`,
      },
      {
        type: 'hideLayoutComponent',
        data: `SearchResults`,
      },
      {
        type: 'showLayoutComponent',
        data: `SearchMoreResults`,
      },
      {
        type: 'setLayoutProperty',
        data: {
          path: `components.SearchResultsCategory.properties`,
          value: {
            category: searchCategory,
            locale,
            currency,
            callbackMode: context.callbackMode,
          },
        },
      },
    ],
  };
};
